import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/lib/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          lighten2: "#002080",
          base: "#162F57",
        },
        secondary: {
          base: "#FBD502",
        },
        grey: {
          lighten4: "#F2F2F2",
          lighten2: "#d7d7d7",
          base: "#2C2C2C",
        },
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  icons: {
    iconfont: "fa",
  },
});
